












import { Component, Prop, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component({})
export default class AtomCheckBox2 extends ComponentVue {
  @Prop({ type: String })
  name!: string

  @Prop({ type: String })
  label!: string

  @Prop({ type: Boolean })
  checked!: boolean

  @Prop({ type: [String, Boolean, Number] })
  value!: string | boolean | number

  @Prop({ type: Boolean, default: false })
  small!: boolean

  @Emit('change')
  onChange(): string | boolean | number {
    this.$logger.debug('AtomCheckBox', 'onChange', 'value=', this.value)
    return this.value
  }

  get classes() {
    return {
      small: this.small
    }
  }
}
